export default __webpack_public_path__ + "img/pin_icons/monitor_b.png";